import React from "react";
import { canReplay, canTrack } from "./dispatchRules";

/** How many action buttons a ride shows (same conditions as the buttons below). */
export const actionCount = (ride) => [canTrack(ride), canReplay(ride), Boolean(ride.employeeNo)].filter(Boolean).length;

/** Most buttons of the given rides (at least one): the actions column is that wide. */
export const mostActions = (rides) => Math.max(1, ...(rides ?? []).map(actionCount));

/** Width of the actions column for that many buttons: 30px buttons, 4px gaps, 6px cell padding, 4px spare. */
export const actionsWidth = (buttons) => 16 + Math.max(1, buttons) * 30 + (Math.max(1, buttons) - 1) * 4;

/**
 * A ride's actions (grid cell and card): Live tracking (on job), Replay (completed with GPS times and a vehicle) and the
 * crew's mobile view. onTrack / onReplay / onMobile(ride).
 */
export default function RideActions({ ride, onTrack, onReplay, onMobile, large = false }) {
  const cls = `dsp-act${large ? " dsp-act--lg" : ""}`;
  return (
    <span className="dsp-acts">
      {canTrack(ride) && (
        <button type="button" className={`${cls} is-live`} title="Live tracking" aria-label={`Live tracking ride ${ride.rideId}`} onClick={() => onTrack(ride)}>
          <i className="fas fa-satellite-dish" aria-hidden="true" />
          {large && <span>Track</span>}
        </button>
      )}
      {canReplay(ride) && (
        <button type="button" className={cls} title="Replay trip" aria-label={`Replay ride ${ride.rideId}`} onClick={() => onReplay(ride)}>
          <i className="fas fa-play-circle" aria-hidden="true" />
          {large && <span>Replay</span>}
        </button>
      )}
      {ride.employeeNo && (
        <button
          type="button"
          className={cls}
          title="Crew app view"
          aria-label={`Crew app view ride ${ride.rideId}`}
          onClick={() => onMobile(ride)}
        >
          <i className="fas fa-mobile-alt" aria-hidden="true" />
          {large && <span>Crew app view</span>}
        </button>
      )}
    </span>
  );
}
